<template>
  <div class="app"> 
    <AppHeader/>
    <div class="app-body">
      <Sidebar :navItems="nav"/>
      <main class="main" :class="isDark ? 'bg-gray-700 text-light' : 'bg-gray-100'">
        <breadcrumb :list="list"/>
        <div class="container-fluid">
      <b-modal id="modal-aguardando"
        centered 
        hide-footer
        hide-header
        hide-header-close
        :cancel-disabled="true" 
        :no-close-on-backdrop="true"
        :no-close-on-esc="true"
        body-class="p-0"
        content-class="border-0 shadow-lg"
        @ok="$store.commit('controle/setAguardando', false)">
            <div class="modern-loading-container">
              <!-- Spinner moderno -->
              <div class="loading-spinner-wrapper">
                <div class="modern-spinner"></div>
                <img src="/static/img/logo-symbol.png" alt="Logo" class="spinner-logo">
              </div>
              
              <!-- Título -->
              <h4 class="loading-title">Processando Requisição</h4>
              
              <!-- Mensagem principal -->
              <p class="loading-message">Por favor, aguarde...</p>
              
              <!-- Mensagem após 5 segundos com animação -->
              <transition name="fade-slide">
                <div v-if="showRefreshMessage" class="refresh-message-box">
                  <i class="fa fa-info-circle mr-2"></i>
                  <div>
                    <strong>Está demorando muito?</strong>
                    <p class="mb-0">
                      Pressione <kbd>F5</kbd> ou clique no botão de atualizar do navegador para recarregar a página
                    </p>
                  </div>
                </div>
              </transition>
            </div>
          </b-modal>
          <b-toast
            v-for="(toast, index) in toasts"
            :key="index"
            :title="toast.titulo"
            :variant="toast.variant"
            :autoHideDelay="toast.tempo"
            solid
            toaster="b-toaster-top-right"
            :visible="true"
          >
            {{ toast.mensagem }}
          </b-toast>
          <router-view></router-view>
        </div>
      </main>
      
      <AppAside/>
    </div>
    <!--
    <AppFooterGhost :visible="ghost.on">
      <component v-if="ghost.cmp" :is="ghost.cmp" v-bind="ghost.props" v-on="ghost.listeners"/>
    </AppFooterGhost>
    -->
    <AppFooterTools v-show="tools.visible">
      <CecPageBar v-bind="tools.props" v-on="tools.listeners" />
    </AppFooterTools>
    <AppFooter/>
  </div>
</template>

<script>
import nav from '../_nav'
import { Header as AppHeader, Sidebar, Aside as AppAside, Footer as AppFooter, Breadcrumb} from '../components/'
import { mapState } from 'vuex'
import AppFooterTools from '../components/AppFooterTools.vue'
import CecPageBar from '../components/Cec/CecPageBar.vue'


export default {
  name: 'full',
  components: {
    AppHeader,
    Sidebar,
    AppAside,
    AppFooter,
    Breadcrumb,
    AppFooterTools,
    CecPageBar

  },
  data () {
    return {
      nav: nav.items,
      menu: [],
      tools: { visible: false, props: {}, listeners: {} },
      showRefreshMessage: false,
      loadingTimer: null
    }
  },
  computed: {
    isDark() {return this.$store.getters['tema/IS_DARK'] 
    },
    // continua sendo reativo e bidirecional com Vuex
    aguardando: {
      get() {
        
        return this.$store.getters['controle/aguardando']
      },
      set(value) {
        this.$store.commit('controle/setAguardando', value)
      }
    },

    // usa mapState para acessar diretamente a lista de toasts da store
    ...mapState('mensagem', ['toasts']),

    // nome da rota atual
    name() {
      return this.$route.name
    },

    // lista de rotas aninhadas (para o breadcrumb)
    list() {
      return this.$route.matched
    }
  },
  watch: {
    isDark(newVal) {
      this.syncTheme(newVal)
    },
    aguardando(newVal) {
      // Programmatically show/hide the modal to avoid z-index/stacking issues
      // when other modals are open. This complements the v-model binding.
      try {
        if (newVal) {
          this.$bvModal.show('modal-aguardando')
          // Inicia timer para mostrar mensagem após 5 segundos
          this.showRefreshMessage = false
          this.loadingTimer = setTimeout(() => {
            this.showRefreshMessage = true
          }, 5000)
        } else {
          this.$bvModal.hide('modal-aguardando')
          // Limpa o timer quando o loading é fechado
          if (this.loadingTimer) {
            clearTimeout(this.loadingTimer)
            this.loadingTimer = null
          }
          this.showRefreshMessage = false
        }
      } catch (e) {
        // ignore if bvModal not available yet
      }
    }
  },
  methods: {
    syncTheme(isDark) {
      if (isDark) {
        document.body.classList.add('theme-dark')
      } else {
        document.body.classList.remove('theme-dark')
      }
    },
    criar() {
      /** CRIA OU NÃO CRIA O MENU
       * DEPENDE SE A PAGINA DE LOGIN CRIOU
       * OU SE FOI UM REFRESH QUE APAGOU O MENU STORE
       */
      let menu = this.$store.getters['menu/LISTA']
      //SE NAO TEM MENU CRIA E PASSA O MENY PARA O METODO GERAR
      if (!menu.length) {
        this.$store.dispatch('menu/GERAR_LISTA')
        .then(result => {
          this.criarMenu(this.$store.getters['menu/LISTA'])
        }) 
      } else { //SE TEM MENU ENTAO SO PASSO MENU PARA A METODO GERAR
        this.criarMenu(menu)
      }
    },
    criarMenu(menus) {
      this.tableItemsContas = []
      this.nav = []
      if (menus && menus.length) {
        let i
        for (i = 0; i < menus.length; i++) {
          if (menus[i].UNICO === 'S') {
            this.nav.push({
              name: menus[i].NAME,
              url: menus[i].URL,
              icon: menus[i].ICON,
              badge: {
                variant: menus[i].VARIANT,
                text: menus[i].TEXT
              }
            })
          }
        }
        for (i = 0; i < menus.length; i++) {
          if (menus[i].TITLE === 'true') {
            this.nav.push({
              title: menus[i].TITLE,
              name: menus[i].NAME,
              class: menus[i].CLASS,
              wrapper: {
                element: menus[i].ELEMENT,
                attributes: {}
              }
            })
            let j
            for (j = 0; j < menus.length; j++) {
              if ((menus[j].PAI_ID === menus[i].ID) && (menus[j].EXIBIR == 'S' ) ) {
                let m = {
                  name: menus[j].NAME,
                  url: menus[j].URL,
                  icon: menus[j].ICON,
                  children: []
                }
                let l
                for (l = 0; l < menus.length; l++) {
                  if ( (menus[l].PAI_ID === menus[j].ID) && (menus[l].EXIBIR == 'S' ) ) {
                    let children = {
                      name: menus[l].NAME,
                      url: menus[l].URL,
                      icon: menus[l].ICON
                    }
                    m.children.push(children)
                  }
                }  
                this.nav.push(m)
              }
            }
          }
        }
      }
      
    },
    criarMenu_antigo () {
      let uri = this.$http.defaults.baseURL.concat(`api/protected/menu/listarporusuario?usuarioid=${window.localStorage.getItem('login')}`)
      let promise = this.$http.get(uri)
      this.tableItemsContas = []
      this.nav = []
      promise.then((data) => {
        if (data) {
          let i
          for (i = 0; i < data.data.length; i++) {
            if (data.data[i].UNICO === 'S') {
              this.nav.push({
                name: data.data[i].NAME,
                url: data.data[i].URL,
                icon: data.data[i].ICON,
                badge: {
                  variant: data.data[i].VARIANT,
                  text: data.data[i].TEXT
                }
              })
            }
          }
          for (i = 0; i < data.data.length; i++) {
            if (data.data[i].TITLE === 'true') {
              this.nav.push({
                title: data.data[i].TITLE,
                name: data.data[i].NAME,
                class: data.data[i].CLASS,
                wrapper: {
                  element: data.data[i].ELEMENT,
                  attributes: {}
                }
              })
              let j
              for (j = 0; j < data.data.length; j++) {
                if (data.data[j].PAI_ID === data.data[i].ID) {
                  let m = {
                    name: data.data[j].NAME,
                    url: data.data[j].URL,
                    icon: data.data[j].ICON,
                    children: []
                  }
                  let l
                  for (l = 0; l < data.data.length; l++) {
                    if (data.data[l].PAI_ID === data.data[j].ID) {
                      let children = {
                        name: data.data[l].NAME,
                        url: data.data[l].URL,
                        icon: data.data[l].ICON
                      }
                      m.children.push(children)
                    }
                  }
                  this.nav.push(m)
                }
              }
            }
          }
        }
      })
    }
  },
  created () {
    this.syncTheme(this.isDark)
    this.criar()// páginas disparam estes eventos para mostrar/atualizar/ocultar

    // Eventos simples para mostrar/atualizar/ocultar a barra
    this.$root.$on('tools:show', ({ props, listeners }) => {
      this.tools = { visible: true, props: props || {}, listeners: listeners || {} }
    })
    this.$root.$on('tools:update', (patch) => {
      this.tools = { ...this.tools, props: { ...this.tools.props, ...(patch || {}) } }
    })
    this.$root.$on('tools:hide', () => {
      this.tools = { visible: false, props: {}, listeners: {} }
    })
  },
  beforeDestroy(){
    this.$root.$off('tools:show'); this.$root.$off('tools:update'); this.$root.$off('tools:hide')
    // Limpa o timer se o componente for destruído
    if (this.loadingTimer) {
      clearTimeout(this.loadingTimer)
    }
  }
}
</script>

<style>
/* Remove fundo branco do modal */
#modal-aguardando .modal-content {
  background: transparent !important;
  border: none !important;
  box-shadow: none !important;
}

#modal-aguardando .modal-body {
  padding: 0 !important;
}
</style>

<style scoped>
/* Container do Loading Moderno */
.modern-loading-container {
  padding: 3rem 2rem;
  text-align: center;
  background: linear-gradient(135deg, rgba(52, 58, 64, 0.96) 0%, rgba(33, 37, 41, 0.96) 100%);
  border-radius: 16px;
  overflow: hidden;
  backdrop-filter: blur(10px);
}

/* Wrapper do Spinner */
.loading-spinner-wrapper {
  margin-bottom: 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}

/* Spinner Moderno Animado */
.modern-spinner {
  width: 80px;
  height: 80px;
  border: 6px solid rgba(32, 168, 216, 0.2);
  border-top: 6px solid #20a8d8;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  box-shadow: 0 0 20px rgba(32, 168, 216, 0.3);
}

/* Logo dentro do spinner */
.spinner-logo {
  width: 45px;
  height: 45px;
  object-fit: contain;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* Título */
.loading-title {
  color: #ffffff;
  font-weight: 700;
  font-size: 1.5rem;
  margin-bottom: 0.5rem;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

/* Mensagem principal */
.loading-message {
  color: rgba(255, 255, 255, 0.85);
  font-size: 1rem;
  margin-bottom: 1rem;
}

/* Box da mensagem de refresh */
.refresh-message-box {
  background: rgba(255, 255, 255, 0.97);
  border-radius: 10px;
  padding: 1rem 1.5rem;
  margin-top: 2rem;
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  text-align: left;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  border-left: 4px solid #ffc107;
}

.refresh-message-box i {
  color: #ffc107;
  font-size: 1.5rem;
  margin-top: 0.25rem;
}

.refresh-message-box strong {
  color: #2c3e50;
  font-size: 1rem;
  display: block;
  margin-bottom: 0.25rem;
}

.refresh-message-box p {
  color: #5a6c7d;
  font-size: 0.9rem;
  line-height: 1.5;
}

.refresh-message-box kbd {
  background-color: #2c3e50;
  color: #ffffff;
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  font-size: 0.85rem;
  font-weight: 600;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
}

/* Animações de transição */
.fade-slide-enter-active {
  animation: fadeSlideIn 0.5s ease-out;
}

.fade-slide-leave-active {
  animation: fadeSlideOut 0.3s ease-in;
}

@keyframes fadeSlideIn {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeSlideOut {
  from {
    opacity: 1;
    transform: translateY(0);
  }
  to {
    opacity: 0;
    transform: translateY(-10px);
  }
}
</style>



// WEBPACK FOOTER //
// src/containers/Full.vue